import { Checkbox, withTooltip } from 'uikit';
import type { WithTooltipProps, CheckboxProps } from 'uikit';

import cn from 'classnames';

import Styles from './withTooltip.module.css';

const CheckboxWithToolTipHoc = withTooltip({
    mode: 'mouseover',
    // @ts-ignore
})(Checkbox);

export const CheckboxWithToolTip = ({
    checkboxProps,
    tooltipProps,
    fakeDisabled = false,
}: {
    checkboxProps: CheckboxProps;
    tooltipProps: WithTooltipProps;
    fakeDisabled?: boolean;
}) => {
    const { className: checkboxClassName, ...otherCheckboxProps } = checkboxProps ?? {};

    return (
        <CheckboxWithToolTipHoc
            // @ts-ignore
            className={cn(checkboxClassName, { [Styles.fakeDisabled]: fakeDisabled })}
            {...otherCheckboxProps}
            tooltipProps={{ className: Styles.tooltip, ...tooltipProps }}
        />
    );
};

CheckboxWithToolTip.displayName = 'CheckboxWithToolTip';
